import React, { useState, useEffect, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import { useParams, useHistory, Link } from 'react-router-dom'
import '@/assets/scss/pages/invoices.scss'
import { trans } from '../../../../_providers/Translation'

//modals
import AddInvoice from './modals/AddInvoice'

//partials
import InvoicesTable from '../../../partials/InvoicesTable'

function Invoices(props) {

    const newInvoiceModalRef = useRef(null)

    const [state, setState] = useState({
        data: [],
        loading: true,
        update: false
    })

    const params = useParams()
    const history = useHistory()

    const id = params.id

    useEffect(() => {
        loadData()
    }, [state.update])

    const loadData = () => {

        setState(prev => ({
            ...prev,
            loading: true
        }))

        Api.get(`reservations/invoices?id=${id}`)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data,
                    loading: false,
                }))
            })

    }

    const refreshData = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))

        props.refreshData()
    }

    const handleAdd = () => {
        newInvoiceModalRef.current.open(id)
    }

    const handleDelete = () => {
        history.push(`?tab=invoices&indicator=${new Date().getTime()}`)
    }


    return (
        <div id='reservation-invoices'>
            <AddInvoice
                ref={newInvoiceModalRef}
                data={props.data}
                refreshData={refreshData}
            />
            <div className='pannel'>

                <div className='head'>
                    <div className='left'>
                        {trans('tabs.invoices')}
                    </div>
                    <div className='right'>
                        {props.data.can_modify && props.data && props.data.can_generate_invoice &&
                            <button className="button button-add button-small" onClick={handleAdd}>
                                {trans('buttons.newDocument')}
                            </button>
                        }
                    </div>
                </div>

                <InvoicesTable
                    loading={state.loading}
                    invoices={state.data}
                    canModify={props.data.can_modify}
                    refreshData={refreshData}
                    handleDelete={handleDelete}
                />

            </div>
        </div>
    )
}

export default Invoices